import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export type DeletePinPayload = {
  note: string;
  intervention_id?: number;
  question_result_id?: number;
};

export const useDeletePinMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeletePinPayload) => {
      await ApiInstance.post("/pins/delete", payload);
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(({ id }) => id === payload.intervention_id);
      if (interventionIdx < 0) return;

      const intervention = appointment.interventions[interventionIdx];
      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, { ...intervention, pin_history: [] })
      });
    }
  });
